module.exports = __webpack_public_path__ + "img/bending.3d68766f.svg";